import * as React from 'react';

import { MarkdownLite, Text } from '@origin-digital/ods-core';

import { IBanner } from '../../../../models/content.interfaces';
import { DangerousHtml } from '../../../DangerousHtml';
import { getCloudinaryUrl } from '../../../../services/cloudinary';
import { IVerticalOffset } from '../../../Container';
import { BannerPostcodePrompt as PostcodePrompt } from '../../../BannerPostcodePrompt/variants/Orange/BannerPostcodePrompt';
import { CallToActions } from '../../../CallToAction';

import {
  BannerContainer,
  ContentContainer,
  ContentSpacing,
  Description,
  Disclaimer,
  Title,
} from './BannerImage.styles';

export const BannerImage = ({
  headline,
  bylineHtml,
  ctas,
  image,
  imageAltText,
  disclaimerText,
  postcodeEntry = false,
}: IBanner & IVerticalOffset) => {
  const classSuffix = postcodeEntry ? '--postcode' : '';
  return (
    <BannerContainer
      title={imageAltText}
      data-comment="BannerImage"
      backgroundImage={getCloudinaryUrl(image)}
      className={`banner${classSuffix}`}
    >
      <ContentContainer className={`content${classSuffix}`}>
        <ContentSpacing className={`content-spacing${classSuffix}`}>
          <Title className={`heading${classSuffix}`}>
            <DangerousHtml html={headline} />
          </Title>
          <Description>
            <Text>
              <MarkdownLite>{bylineHtml}</MarkdownLite>
            </Text>
          </Description>
          {postcodeEntry ? (
            <>
              <Description noMargin>Your postcode</Description>
              <PostcodePrompt />
            </>
          ) : (
            <CallToActions ctas={ctas} trackingCode="bannerButton" />
          )}
          {disclaimerText ? (
            <Disclaimer>
              <Text>
                <MarkdownLite>{disclaimerText}</MarkdownLite>
              </Text>
            </Disclaimer>
          ) : null}
        </ContentSpacing>
      </ContentContainer>
    </BannerContainer>
  );
};
